import PreloadImage from './PreloadImage'
import withScroll from './withScroll'
import { AppContext, withApp } from './AppContext'
import ScrollTo from 'scroll-to'

export const getGreetHour = () => {
  const hour = new Date().getHours()
  let sHour = 0

  if(hour >= 0 && hour < 7) {
    sHour = 0
  }

  if(hour > 7 && hour < 12) {
    sHour = 7
  }

  if(hour > 12 && hour < 18) {
    sHour = 12
  }

  if(hour > 18 && hour <= 23) {
    sHour = 18
  }

  return sHour
}

const checkIE11 = () => {
  // return !!window.MSInputMethodContext && !!document.documentMode

  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

const getItemById = (list, id) => {
  if(!list) return {}

  return list.find(item => item.id === id) || {}
}

const createChunks = (list, num) => {
  return list.reduce((acc, obj, idx) => {
    const chunk = Math.floor(idx / num)
    acc[chunk] = [].concat((acc[chunk] || []), obj)
    return acc
  }, [])
}

const compareAnswers = (type, arr1, arr2) => {
  let correct = 0
  let wrong = 0

  if(type === 'single' || type === 'multiple')
    arr2.map(item => arr1.find(itm => itm === item) ? correct++ : wrong++)

  if(type === 'dragdrop')
    arr2.map(item => arr1.find(itm => itm.aId === item.aId && itm.location === item.location) ? correct++ : wrong++)

  return { correct, wrong }
}

// const compareAnswers = (arr1, arr2) => {
//   if(arr1.length !== arr2.length) return false
//   for(let i=arr1.length; i--;) {
//     if(arr1[i].id !== arr2[i].id) return false
//   }
//   return true
// }

const shuffleArray = array => array.sort(() => .5 - Math.random())
const getRandomItemFromArray = (array, count) => shuffleArray(array).slice(0,count)

const scrollTop = (top, dur) => {
  ScrollTo(0, top || 0, {
    ease: 'out-circ',
    duration: dur || 600
  })
}


/*!
 * Merge two or more objects together.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
 * @param   {Object}   objects  The objects to merge together
 * @returns {Object}            Merged values of defaults and options
 */
export const deepMerge = function () {

	// Variables
	var extended = {};
	var deep = false;
	var i = 0;

	// Check if a deep merge
	if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
	    deep = arguments[0];
	    i++;
	}

	// Merge the object into the extended object
	var merge = function (obj) {
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				// If property is an object, merge properties
				if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
					extended[prop] = deepMerge(extended[prop], obj[prop]);
				} else {
					extended[prop] = obj[prop];
				}
			}
		}
	};

	// Loop through each object and conduct a merge
	for (; i < arguments.length; i++) {
		merge(arguments[i]);
	}

	return extended;

};

export {
  getItemById,
  createChunks,
  compareAnswers,
  shuffleArray,
  getRandomItemFromArray,
  PreloadImage,
  withScroll,
  AppContext,
  withApp,
  scrollTop,
  checkIE11,
}
export { default as withClickOutside } from './withClickOutside'
